import './App-aondirect.vue'
import './main.js'



// WEBPACK FOOTER //
// ./src/main/frontend/main-aondirect.js